module.exports = __webpack_public_path__ + "img/office-4.f940b6ae.jpg";